export default "__VITE_ASSET__9a1f00bf__"